import React from 'react';
import { ActivityIcon, BookOpenIcon, CalendarDaysIcon, ClockIcon } from 'lucide-react';
import { differentiators } from '../data/content';
import { Mark, SectionTitle } from './ui/Section';
const icons = {
  book: BookOpenIcon,
  clock: ClockIcon,
  activity: ActivityIcon,
  calendar: CalendarDaysIcon
};
export function Differentiators() {
  return <section className="bg-white px-4 py-12 md:py-16" data-id="element-44" data-mp="1w5495ijrqy33">
      <div className="mx-auto max-w-5xl" data-id="element-45" data-mp="zdiq7v0zz0og">
        <SectionTitle data-id="element-46" data-mp="zetya71h6uld">
          More than a collection of exercises. <Mark data-id="element-47" data-mp="13fdrizixhe28">A complete professional system.</Mark>
        </SectionTitle>

        <ul className="mt-10 grid gap-x-8 gap-y-8 sm:grid-cols-2" data-id="element-48" data-mp="18cw6b6jmmni5">
          {differentiators.map(item => {
          const Icon = icons[item.icon];
          return <li key={item.title} className="flex gap-4" data-id="element-49" data-mp="2jskt9xwvrmiy">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-brand" data-id="element-50" data-mp="2js2mw8gi7rxb">
                  <Icon className="h-5 w-5 text-accent-light" aria-hidden="true" data-id="element-51" data-mp="2opuet2h5fe1i" />
                </span>
                <div data-id="element-52" data-mp="bo13r4sf4lpu">
                  <h3 className="text-sm font-black uppercase leading-tight text-brand-deep" data-id="element-53" data-mp="7n8w2fz72ovo">{item.title}</h3>
                  <p className="mt-1.5 text-sm leading-snug text-slate-600" data-id="element-54" data-mp="2nvyb06sbxeb">{item.text}</p>
                </div>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}